.buttonsWrapper {
  display: 'flex';
  justify-content: 'flex-end';
  margin-top: 20;
}

.assignButton {
  padding: 0;
}